<template>
<div>
  <img alt="Leadtributor logo" src="../assets/leadtributor-logo-text.png" width="500">

  <v-row justify="center">
    <v-col cols="12">
      <RegisterComponent v-model="registerModel" @register="onRegister">
        <template v-slot:privacy>
          Mit Ihrer Anmeldung erklären Sie sich mit unseren Allgemeinen Geschäftsbedingungen einverstanden. Bitte
          lesen Sie unsere <a>Datenschutzerklärung</a>, unsere <a>Hinweise zu Cookies</a> und unsere Hinweise zu <a>interessenbasierter
          Werbung</a>.
        </template>
        <a>Passwort vergessen?</a>
        <a>Datenschutz</a>
        <a>AGB</a>
      </RegisterComponent>
    </v-col>
    <v-col>
      {{ registerModel }}
    </v-col>
  </v-row>
</div>
</template>

<script>
import RegisterComponent from "@/components/login/RegisterComponent";
import {reactive} from "@vue/composition-api";
export default {
  name: "RegisterView",
  components: {RegisterComponent},
  setup(){
    const registerModel = reactive({
      login: '',
      password: '',
      emailAlreadyUsed: false
    })

    function onRegister(registerData){
      console.log(registerData.login, registerData.password)
      registerData.emailAlreadyUsed = true
    }
    return {registerModel, onRegister}
  }
}
</script>

<style scoped>

</style>
